import { useParsed } from '@refinedev/core';
import { useLocation, Outlet } from 'react-router-dom';
import { useMemo } from 'react';
import {
    PublicLayout,
    PrivateLayout,
    DashboardLayout,
    DashboardInternalLayout,
} from '../layout';

export const AppLayout = () => {
    const { resource, action } = useParsed();
    const { pathname } = useLocation();

    const layoutType = useMemo(() => {
        if (
            resource?.meta?.internalLayoutActions &&
            action &&
            resource.meta.internalLayoutActions.includes(action)
        ) {
            return 'dashboard-internal';
        }

        if (resource?.meta?.layout) return resource.meta.layout;

        if (pathname.startsWith('/login')) return 'public';
        if (pathname.startsWith('/applications')) {
            if (/\/applications\/(create|edit|add)/.test(pathname)) {
                return 'dashboard-internal';
            }

            return 'dashboard';
        }

        return 'private';
    }, [resource, action, pathname]);

    switch (layoutType) {
        case 'public':
            return (
                <PublicLayout>
                    <Outlet />
                </PublicLayout>
            );
        case 'dashboard':
            return (
                <DashboardLayout>
                    <Outlet />
                </DashboardLayout>
            );
        case 'dashboard-internal':
            return (
                <DashboardInternalLayout>
                    <Outlet />
                </DashboardInternalLayout>
            );
        default:
            return (
                <PrivateLayout>
                    <Outlet />
                </PrivateLayout>
            );
    }
};
